import * as React from 'react';

interface ITicketListProps {

}

interface ITicketListState {
    ticketResponse?: ITicketListResponse;
}

interface ITicketData {
    id: number;
    subject: string;
    status: string;
    requesterId: number;
    requester: string;
    assignedTo: string;
    dateCreated: string;
    dateUpdated: string;
    //topic: string;               -- not available in the CompTIA Zendesk instance
    history: string;
}

interface ITicketListResponse {
    tickets: Array<ITicketData>;
    error: string;
    isBeginning: boolean;
    isEnd: boolean;
}

export default class TicketList extends React.PureComponent<ITicketListProps, ITicketListState> {
    _page: number = 0;
    constructor(props: ITicketListProps) {
        super(props);
        this.state = {};
    }

    closeForm() {
        window.parent.postMessage(JSON.stringify({ "action": "DONE" }), "*");
    }

    fetchPage() {
        this.setState({ ticketResponse: undefined }, async () => {
            let response = await fetch(`/api/ticketlist/tickets${window.location.search}&page=${this._page}`);
            let data = await response.json() as ITicketListResponse;
            this.setState({ ticketResponse: data });
        });
    }

    prevClick() {
        this._page--;
        this.fetchPage();
    }

    nextClick() {
        this._page++;
        this.fetchPage();
    }

    componentDidMount() {
        this.fetchPage();
    }

    render() {
        return <div>
            {this.state.ticketResponse == null && <div>
                <div className="spinner-border text-warning" style={{ "width": "10rem", "height": "10rem", "position": "absolute", "left": "calc(50% - 80px)", "top": "calc(50% - 125px)" }} role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>}
            {this.state.ticketResponse != null && <div>
                {this.state.ticketResponse.error != null && <div className="alert alert-danger text-center">
                    {this.state.ticketResponse.error}
                </div>}
                <div className="container">
                    <div className="card text-break">
                        <div className="card-body list-group bg-light p-4">
                            {this.state.ticketResponse.tickets.map((ticket, idx) => {
                                return <div key={idx} className="list-group-item mb-3">
                                    <div className="float-left">
                                        <div><strong>Ticket #<a href={`https://comptia.zendesk.com/agent/tickets/${ticket.id}`} target="_blank">{ticket.id}</a> &nbsp;&nbsp;Subject:</strong> {ticket.subject}</div>
                                        <div>
                                            <strong>Status:</strong> {ticket.status}&nbsp;&nbsp;
                                            <strong>Requester:</strong>&nbsp;
                                            {ticket.requesterId != null && <a href={`https://app.hubspot.com/contacts/3302827/contact/${ticket.requesterId}`} target="_blank">{ticket.requester}</a>}
                                            {ticket.requesterId == null && <span>{ticket.requester}</span>}
                                            &nbsp;&nbsp;
                                            <strong>Assigned To:</strong> {ticket.assignedTo}
                                        </div>
                                        <div><strong>Created:</strong> {ticket.dateCreated} &nbsp;&nbsp;<strong>Last Updated:</strong> {ticket.dateUpdated}</div>
                                        {/*<div><strong>Topics:</strong> {ticket.topic}</div>  -- not available in the CompTIA Zendesk instance*/}
                                        <div dangerouslySetInnerHTML={{ __html: ticket.history }} />
                                    </div>
                                </div>;
                            })}
                        </div>
                    </div>
                    <div className="container mt-2">
                        <button type="button" className="float-right btn btn-secondary ml-2" onClick={() => { this.closeForm() }}>Close</button>
                        {!this.state.ticketResponse.isEnd && <button type="submit" className="float-right btn btn-primary ml-2" onClick={() => { this.nextClick() }}>Next tickets</button>}
                        {!this.state.ticketResponse.isBeginning && <button type="submit" className="float-right btn btn-primary ml-2" onClick={() => { this.prevClick() }}>Prev tickets</button>}
                    </div>
                </div>
            </div>}
        </div>;
    }
}